import React from 'react';
import { Navigate } from 'react-router-dom';

import { CreditFacilityBankAccountsContainer } from './CreditFacilityAccountsContainer';
import { useCreditFacilitiesOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { PageHeader } from '~/packages/common-frontend/components/PageContainer';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const { facilities } = useCreditFacilitiesOrThrow();

  if (facilities.length === 0) {
    throw Error(
      `Borrower ${user.organization.slug} should have at least one existing credit facility`,
    );
  }

  return (
    <>
      <PageHeader headerLabel="Bank accounts" marginBottom="30px" />
      {facilities.map((creditFacility, idx) => (
        <CreditFacilityBankAccountsContainer
          borrowerId={user.organizationId}
          creditFacilityId={creditFacility.id}
          creditFacilityName={creditFacility.name}
          creditFacilityNumber={idx + 1}
          key={creditFacility.id}
        />
      ))}
    </>
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.userType !== 'BORROWER') return 'deny';
  if (context.flags.isBorrowerLimitedOrganization) return 'upsell';
  return 'allow';
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/settings" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  </PermissionGuard>
);
